import { inject, Injectable } from '@angular/core';
import { PublicServoAntragSignApiService, PublicServoAntragSignInfoDto, PublicServoAntragSignSubmitDto } from '@base/backend';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SignatureService {
  private readonly publicServoAntragSignApiService = inject(PublicServoAntragSignApiService);

  getSignatureInformation(servoContractId: string, oneTimeToken: string): Observable<PublicServoAntragSignInfoDto> {
    return this.publicServoAntragSignApiService
      .apiPublicServoAntragSignContractServoContractIdSignatureInfoGet(servoContractId, oneTimeToken);
  }

  save(servoContractId: string, dto: PublicServoAntragSignSubmitDto) {
    return this.publicServoAntragSignApiService
      .apiPublicServoAntragSignContractServoContractIdPost(servoContractId, dto);
  }

  downloadOffert(contractId: string, token: string): Observable<Blob> {
    return this.publicServoAntragSignApiService
      .apiPublicServoAntragSignContractServoContractIdAntragPreviewGet(contractId, token);
  }
}
